import React, { useContext as useContextCore } from 'react'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, onFilter, category, filterFields, ...props }) => {
  const [activeTemplate, setActiveTemplate] = React.useState(null)

  return <CoreProvider value={{ ...props, onFilter, category, filterFields, activeTemplate, setActiveTemplate }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
